<template>
  <div id="app" class="flex-col contrast-dark-400">
    <Alert/>
    <Snack-bar/>
    <Header-side v-if="loggedIn"/>
    <main class="h-full" v-if="loading">
      <div class="flex bg-default flex-1 items-center">
        <loading/>
      </div>
    </main>
    <main class="h-full" v-if="error">
      <div class="flex bg-red-800 flex-1 items-center text-white">
        <div class="w-full text-center">
          {{error}}
        </div>
      </div>
    </main>

    <main class="h-full" v-if="$route.name ==='login'">
      <transition name="fade" mode="out-in">
        <router-view v-if="!loading && !error"/>
      </transition>
    </main>

    <main :class="{}" v-if="$route.name!=='login' && !loading && !error">
      <div class="view bg-default scrollable">
        <transition name="fade" mode="out-in">
        <router-view />
        </transition>
      </div>
    </main>
  </div>
</template>


<script>
  import ApiService from './services/api.service'
  import UserService from './services/user.service'
  import {InitialDataService, SyncDataService} from './services/storage.service'
  import {mapActions, mapGetters, mapMutations} from "vuex"

  import Alert from "./components/Alert"
  import SnackBar from "./components/SnackBar"
  import HeaderSide from "./components/Layout/HeaderSide"

  export default {
    components: {
      Alert,
      SnackBar,
      HeaderSide
    },
    data() {
      return {
        loading: true,
        error: null,
        //service worker
        refreshing: false,
        registration: null
      }
    },
    computed: {
      ...mapGetters('auth', [
        'authenticating',
        'authenticationError',
        'authenticationErrorCode',
        'loggedIn'
      ]),
      ...mapGetters('profile', [
        'logged_user'
      ]),

      ...mapGetters([
        'hasInternetConnection',
      ]),
    },
    watch: {
      loggedIn: function (newValue, oldValue) {
        if (newValue === true) {
          this.setInitialData()
        }
      },
      '$route': function () {

      }

    },
    methods: {
      ...mapMutations('profile', ['update_profile']),
      ...mapActions('auth', ['logout']),
      ...mapMutations('alert', ['alert_fire']),
      //try to set initial data from server or from local storage
      setInitialData() {
        this.loading = true
        if (this.hasInternetConnection) {
          //fetch from server
          this.fetchInitialData()
        } else {
          //fetch from local storage
          this.commitInitialData()
        }
      },
      //if has internet connection fetch from server
      fetchInitialData: async function () {
        const requestData = {
          method: 'get',
          url: "api/quiz/initial_data",
        }

        try {
          const response = await ApiService.customRequest(requestData)
          InitialDataService.refreshInitialData(response.data)

          this.commitInitialData()

          //there is internet and we can sync data
          //TODO::inform user with snack bar (make sync method async...)
          SyncDataService.sync()

        } catch (error) {
          console.log('Initial data error!!!: ' + error.toString());
          this.error = error.toString()
          if (error.response.status === 401 || error.response.status === 404) {
            this.logout()
          } else {
            this.error = error.toString()
          }
        }
      },
      //commit initial data to vuex from local storage
      commitInitialData() {
        let data = InitialDataService.getInitialData()
        this.update_profile(data.profile)
        this.loading = false
      },

      showRefreshUI(e){
        this.registration = e.detail;
        this.alert_fire({
          'title': 'Налична е нова версия!',
          'message': 'Да обновя ли приложението?',
          'callback' : this.refreshApp
        })
      },
      refreshApp () {
        if (!this.registration || !this.registration.waiting) { return; }
        this.registration.waiting.postMessage('skipWaiting');
      },
    },
    mounted() {
      if (this.loggedIn === true) {
        this.setInitialData()
      } else {
        this.loading = false
      }

      // window.addEventListener('beforeunload', (event) => {
      //   //Add condition to not leave page...
      //   if(false) {
      //     // Cancel the event as stated by the standard.
      //     event.preventDefault();
      //     // Chrome requires returnValue to be set.
      //     event.returnValue = '';
      //   }
      // });
    },
    created() {
      document.addEventListener(
              'swUpdated', this.showRefreshUI, {once: true}
      )
      navigator.serviceWorker.addEventListener(
              'controllerchange', () => {
                if (this.refreshing) return
                this.refreshing = true
                window.location.reload()
              }
      )
    },
  }
</script>
